import { render, staticRenderFns } from "./ArticlesCourse.vue?vue&type=template&id=5a39d5e0&"
import script from "./ArticlesCourse.vue?vue&type=script&lang=js&"
export * from "./ArticlesCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports